export default __webpack_public_path__ + "static/media/backgroundFooter.23e3be87.svg";